








import {Component, Vue} from 'vue-property-decorator';
import {TITLE_DEFAULT} from "@/App/data/define";

@Component
export default class Error404Page extends Vue {
    public readonly name: string = 'error-404-page'

    private created(): void {
        document.title = "Ошибка, такой страницы нет - " + TITLE_DEFAULT
    }
}
